import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {ToastContainer, toast} from 'react-toastify';
import FadeLoader from 'react-spinners/FadeLoader';
import {isEmpty} from 'lodash';
import {Redirect, Link} from 'react-router-dom';

import {getToken, getUser} from '../../utils/TokenManager';
import * as AuthAction from "../../actions/AuthAction";
import LoginService from '../../services/LoginService';
import logo from '../../public/assets/images/symphony_logo_new.jpg';
import loginImg from '../../public/assets/images/login-img.jpg';
import {css} from 'react-emotion';

const override = css`
    margin: auto;
`;

class RecoveryForm extends Component {
    state = {
        isLoading: false,
        email: ''
    };

    onChange = (event) => {
        return this.setState({email: event.target.value});
    };

    submitEmail = async (e) => {
        e.preventDefault();
        if (this.state.email.trim()) {
            this.setState({isLoading: true});
            try {
                let result = await LoginService.submitEmail(this.state.email);
                if (200 === result.status) {
                    toast.success("A recovery email has been sent to your email id. Please check and follow the instructions. In case of any difficulties, Please contact support.");
                    this.setState({email: ''});
                }
            } catch (error) {
                if (error.response && error.response.status) {
                    toast.error("Given Email-id is not registered in symphony database.");
                } else {
                    console.log(error.response.data);
                }
            }
            this.setState({
                isLoading: false
            });
        } else {
            toast.error("Enter email id.");
        }
        return false;
    };

    render() {
        const {isLoading} = this.state;
        const {auth} = this.props;

        if (auth.isAuthenticated || (typeof getToken() && !isEmpty(getToken()))) {
            if (getUser().is_installation_completed) {
                let prevURL = this.props.prevURL;
                if (
                    prevURL === '/' || prevURL === '/login' || 
                    prevURL === '/recovery' || prevURL === '/reset-password'
                ) {
                    prevURL = '/home'
                }
                return (<Redirect to={prevURL} />);
            } else {
                return (<Redirect to="/installation-wizard" />);
            }
        }

        return (
            <div className="login-page">
                <div className="login-box">
                    <div className="left-login-box">
                        <img src={loginImg} height="100%" alt="Login" />
                    </div>
                    <div className="right-login-box">
                        <img src={logo} alt="Logo" className="login-logo" />
                        <form className="auth-form">
                            <div className="border p-3">
                                <label>
                                    Enter your registered e-mail id below and 
                                    we will send you instructions how to recover a password.
                                </label>
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text bg-success text-white" id="basic-addon1">
                                            <i className="fa fa-user" aria-hidden="true"></i>
                                        </span>
                                    </div>
                                    <input className="form-control form-control-lg"  
                                        name="email" aria-label="email" 
                                        required type="email" 
                                        value={this.state.email} 
                                        onChange={this.onChange} 
                                        placeholder="Email ID" 
                                    />
                                </div>
                                <hr/>
                                <div className="form-group mb-0">
                                    {isLoading ?
                                        <FadeLoader
                                            color={'#4fb8a5'}
                                            loading={isLoading}
                                            size={32}
                                            className={override}
                                        /> :
                                        <div className="d-flex flex-column align-items-center">
                                            <button onClick={this.submitEmail} 
                                                className="btn btn-success w-50 font-weight-bold" 
                                                type="submit"
                                            >Submit</button>
                                            <Link to='/login' className="a-text-underline mt-2">
                                                Back to Login
                                            </Link>
                                        </div>
                                    }
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="mt-2 text-center">
                    <q className="text-left">
                        <i>
                            Success is not final. Failure is not fatal. 
                            It's the courage to continue that counts.
                        </i>
                    </q>
                    <b> - Winston Churchill</b>
                </div>
                <div className="clear login-footer">
                    <p>
                        Need Help? Call Support at 972-961-4798 
                        or email at tom@comp21.biz or
                        <a className="text-success" 
                            href="https://us02web.zoom.us/j/9722396890"
                        > Click Here </a> for a Zoom meeting
                    </p>
                </div>
                <ToastContainer position={toast.POSITION.TOP_CENTER} autoClose={2000}/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        auth: state.AuthReducer
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(AuthAction, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(RecoveryForm);


// WEBPACK FOOTER //
// ./src/components/login/RecoveryForm.js